import Typography from 'typography';
import lincolnTheme from 'typography-theme-lincoln';

lincolnTheme.baseFontSize = '18px';
lincolnTheme.googleFonts = [
    {
        name: 'Open Sans',
        styles: ['400', '700'],
    },
];

/* Header */
lincolnTheme.headerFontFamily = ['Open Sans', 'sans-serif'];
lincolnTheme.headerWeight = 400;
lincolnTheme.headerColor = '#DF003F';

/* Body */
lincolnTheme.bodyFontFamily = ['Open Sans', 'sans-serif'];
lincolnTheme.bodyWeight = 400;
lincolnTheme.boldWeight = 700;
lincolnTheme.bodyColor = '#403E3F';

/* Theme options */
lincolnTheme.baseLineHeight = 1.58;
lincolnTheme.scaleRatio = 2.1;
lincolnTheme.overrideThemeStyles = ({ rhythm }, options) => ({
    'h2,h3': {
        marginBottom: rhythm(1 / 2),
        marginTop: rhythm(1 / 2),
        color: '#403E3F',
    },
    'h4,h5': {
        marginBottom: rhythm(1 / 2),
        marginTop: rhythm(1 / 2),
        color: '#818181',
    },
    /* h8 doesn't exist, but otherwise h1 doesn't override */
    // prettier-ignore
    'h1,h8': {
        marginBottom: rhythm(0.5),
        marginTop: rhythm(1.6),
        textTransform:'uppercase',
        textAlign: 'center',
        letterSpacing: '0.05em'
    },
    blockquote: {},
    p: {
        marginBottom: rhythm(0.8),
        marginTop: rhythm(0.8),
    },
    a: {
        textShadow: 'none',
        backgroundImage: 'none',
    },
});

const typography = new Typography(lincolnTheme);

export default typography;



// WEBPACK FOOTER //
// ./src/utils/typography.js